import { useReducer, useEffect } from 'react'
import { backendGetRequest, backendGetRequestWithCache } from '../../../../../helpers/callBackend'
import { errorMessage } from '../../../../../helpers/errorMessageFunc'
import BankAccountMultiView from '../../../../../components/bankAccount/multiView'

const initialState = {
  tableData: [],
  totalRecords: -1,
  loading: false,
  cachedData: [],
}

const ACTION_TYPES = {
  SET_LOADING: 'SET_LOADING',
  SET_TOTAL_RECORDS: 'SET_TOTAL_RECORDS',
  ADD_TABLE_DATA: 'ADD_TABLE_DATA',
  SET_DISPLAY_DATA: 'SET_DISPLAY_DATA',
  ADD_CACHED_DATA: 'ADD_CACHED_DATA',
}

const setLoadingAction = (isLoading) => {
  return {
    type: ACTION_TYPES.SET_LOADING,
    payload: isLoading,
  }
}

const setTotalRecordsAction = (totalCount) => {
  return {
    type: ACTION_TYPES.SET_TOTAL_RECORDS,
    payload: totalCount,
  }
}

const addTableDataAction = (newData) => {
  return {
    type: ACTION_TYPES.ADD_TABLE_DATA,
    payload: newData,
  }
}

const addCachedDataAction = (newCache) => {
  return {
    type: ACTION_TYPES.ADD_CACHED_DATA,
    payload: newCache,
  }
}

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    case ACTION_TYPES.SET_TOTAL_RECORDS:
      return {
        ...state,
        totalRecords: action.payload,
      }
    case ACTION_TYPES.ADD_TABLE_DATA:
      const newTableData = [...state.tableData, ...action.payload]
      const isLoaded = state.totalRecords > 0 && newTableData.length >= state.totalRecords
      return {
        ...state,
        tableData: newTableData,
        loading: !isLoaded,
      }
    case ACTION_TYPES.ADD_CACHED_DATA:
      return {
        ...state,
        cachedData: [...state.cachedData, ...action.payload],
      }
  }
}

const getPage = (dispatch, pageNum, reportId) => {
  try {
    backendGetRequestWithCache(
      '/api/reports/v2/bank-accounts',
      {
        params: {
          page_index: pageNum,
          report_builder_id: reportId,
        },
      },
      (cachedResp) => {
        if (cachedResp.status === 200) dispatch(addCachedDataAction(cachedResp?.data?.data))
      },
      (realResp) => dispatch(addTableDataAction(realResp?.data?.data))
    )
  } catch (error) {
    errorMessage(error.errorMessage)
  }
}

const getTableData = async (dispatch, reportId) => {
  try {
    dispatch(setLoadingAction(true))
    const infoResp = await backendGetRequest('/api/reports/v2/bank-accounts', {
      params: {
        page_index: 0,
        report_builder_id: reportId,
      },
    })
    const totalRecords = infoResp?.data?.total_records
    const totalPages = infoResp?.data?.total_pages

    dispatch(setTotalRecordsAction(totalRecords))

    for (let pageNum = 1; pageNum <= totalPages; pageNum++) {
      getPage(dispatch, pageNum, reportId)
    }
  } catch (error) {
    errorMessage(error.message)
    dispatch(setLoadingAction(false))
  }
}

const BankAccounts = ({ reportId }) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  useEffect(() => {
    getTableData(dispatch, reportId)
  }, [reportId])

  return (
    <BankAccountMultiView
      allowActions={false}
      accountsInfo={state?.loading ? state?.cachedData : state?.tableData}
      accountTypeTitle='Associated Bank Accounts'
      reportsPage={true}
      loadingTable={state?.loading}
    />
  )
}

export default BankAccounts
